export default __webpack_public_path__ + "d4935240bc678706e7628028e8127657.png";